import React from 'react';
import { X } from 'lucide-react';
import Modal from './common/Modal';
import { Icons } from '@/utils/Icons';

interface AddToHomeScreenModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddToHomeScreenModal: React.FC<AddToHomeScreenModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="380px">
      {/* Header */}
      <div className="flex items-center justify-between bg-btn-gradient px-5 py-3">
        <h2 className="text-white font-semibold text-[18px]">Install App on iPhone</h2>
        <button
          onClick={onClose}
          aria-label="Close"
          className="w-8 h-8 bg-white rounded-md flex items-center justify-center"
        >
          <X className="text-black w-5 h-5" />
        </button>
      </div>

      {/* Body */}
      <div className="flex flex-col gap-4 p-5 bg-modelBg text-black dark:text-white">
        <p className="text-sm text-black/70 dark:text-white/80">
          iOS doesn&apos;t support one-tap installs. Add this app to your Home Screen from Safari
          instead:
        </p>

        <ol className="flex flex-col gap-3 text-sm">
          <li className="flex items-start gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FEC733] text-black text-xs font-bold">
              1
            </span>
            <span>
              Open this site in <strong>Safari</strong>, then tap the{' '}
              <strong>Share</strong> icon (square with an arrow pointing up) in the toolbar.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FEC733] text-black text-xs font-bold">
              2
            </span>
            <span className="flex items-center gap-1.5 flex-wrap">
              Scroll down and tap
              <Icons.PlusSquare size={16} className="inline-block shrink-0" />
              <strong>&quot;Add to Home Screen&quot;</strong>.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FEC733] text-black text-xs font-bold">
              3
            </span>
            <span>
              Tap <strong>&quot;Add&quot;</strong> in the top-right corner to finish.
            </span>
          </li>
        </ol>

        <button
          type="button"
          onClick={onClose}
          className="mt-1 w-full py-2 rounded-full bg-[#FEC733] text-black font-bold"
        >
          Got it
        </button>
      </div>
    </Modal>
  );
};

export default AddToHomeScreenModal;
